import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import $ from "jquery";
import Server from '../../../functions/server';
import Servername from '../../../functions/servername';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loadings';
import { Form, TextArea } from 'semantic-ui-react';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class changeStatus extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    update: false,
    maxWidth: 'xs',
    requestitems: []
  };

  remarks() {
    this.setState({ dialog: true })
  }

  handleClose = () => {
    this.setState({ dialog: false })
  }

  submit(status) {
    if (this.props.placeorderedit == 'none') {
      alert('You are not allow to change!!!!');
      return;
    }
    let context = this;
    let orderData = this.props.data;
    this.setState({
      load: true,
      message: 'Update Status',
    })
    let url = Server() + 'placeorder/updateorderstatus.php';
    if (this.props.from == 'singleStatus') {
      url = Servername() + 'order/updateorderstatus.php';
    }
    $.ajax({
      type: 'POST',
      data: { 'status': status, 'id': context.props.mid },
      url: url,
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        })
        if (data == 1) {
          if (context.props.from == 'singleStatus') {
            orderData.map((o) => {
              if (o.id == context.props.mid) {
                o.status = status;
              }
            })
          }
          else {
            orderData.map((o) => {
              if (o.mid == context.props.mid) {
                if (o.status == 'Waiting' || o.status == 'Prior Order' || o.status == 'Pending For Delivery' || o.status == 'Canceled' || o.status == 'Delivered' || o.status == 'Approved') {
                  o.status = status;
                }
              }
            })
          }
          context.props.seprateMaterDetails(orderData);
          context.setState({ dialog: false })
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        })
      }
    })
  }

  handleTextBox = name => event => {
    this.setState({ [name]: event.target.value })
  }

  render() {
    let i = 0;
    return (
      <div style={{color: '#4574A3'}}>
        <u onClick={this.remarks.bind(this)} id='pointer'>{this.props.status}</u>
        <Loading load={this.state.load} message={this.state.message} />
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.dialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Change Status</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <List>
                  <ListItem id='pointer' onClick={this.submit.bind(this, 'Waiting')} style={{fontSize: 14}}><b>Waiting</b></ListItem>
                  <ListItem id='pointer' onClick={this.submit.bind(this, 'Approved')} style={{fontSize: 14}}><b>Approved</b></ListItem>
                  <ListItem id='pointer' onClick={this.submit.bind(this, 'Prior Order')} style={{fontSize: 14}}><b>Prior Order</b></ListItem>
                  <ListItem id='pointer' onClick={this.submit.bind(this, 'Canceled')} style={{fontSize: 14}}><b>Canceled</b></ListItem>
                </List>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

changeStatus.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(changeStatus);
